import accountManagementActionTypes from './action-types';

export const fetchUserAuthenticationInfo = payload => ({
  type: accountManagementActionTypes.FETCH_USER_AUTHENTICATION_INFO,
  payload,
});

export const fetchUserAuthenticationInfoSuccess = payload => ({
  type: accountManagementActionTypes.FETCH_USER_AUTHENTICATION_INFO_SUCCESS,
  payload,
});

export const fetchUserAuthenticationInfoFail = payload => ({
  type: accountManagementActionTypes.FETCH_USER_AUTHENTICATION_INFO_FAIL,
  payload,
});

export const fetchLoginInfo = payload => ({
  type: accountManagementActionTypes.FETCH_LOGIN_INFO,
  payload,
});

export const fetchLoginInfoSuccess = payload => ({
  type: accountManagementActionTypes.FETCH_LOGIN_INFO_SUCCESS,
  payload,
});

export const fetchLoginInfoFail = payload => ({
  type: accountManagementActionTypes.FETCH_LOGIN_INFO_FAIL,
  payload,
});
